import React, { useCallback, useEffect, useState } from 'react';
import MainLayout from 'src/components/layouts/MainLayout';
import styles from 'src/styles/layout.module.css';
import { Breadcrumb, Button, Form, Input, Row, Space, Spin, Typography } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ClusterOutlined } from '@ant-design/icons';
import tileStyles from 'src/styles/tile.module.css';

import { useForm } from 'antd/es/form/Form';
import { AppDispatch } from 'src/index';
import { createDevice, fetchDeviceTypes } from 'src/features/devicesTypes/devicesTypes.state';
import { useDevicesState, useDevicesTypes } from 'src/features/devicesTypes/devicesTypes.hooks';

const emptyDevice = { name: '' };

const DeviceTypesPage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const types = useDevicesTypes();
  const history = useHistory();

  const [form] = useForm();

  const [createMode, setCreateMode] = useState<boolean>(false);
  const [newEntity, setNewEntity] = useState<{ name: string }>(emptyDevice);

  const handleCreateButtonClick = useCallback(() => {
    setCreateMode(true);
  }, []);

  const handleFormSubmit = useCallback(async () => {
    const response = await dispatch(createDevice(newEntity));

    if (createDevice.fulfilled.match(response)) {
      history.push(`/settings/devices/${response.payload.name}`);
    }
  }, [dispatch, history, newEntity]);

  return (
    <MainLayout>
      <div className={styles.mainGrid}>
        <div className={styles.breadCrumbs}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/settings/devices'>
                <Space>
                  <ClusterOutlined />
                  Типы устройств
                </Space>
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className={styles.contentArea}>
          <Typography.Title level={2} className={styles.title}>
            Типы устройств
          </Typography.Title>
          <div>
            {createMode && (
              <Form
                form={form}
                validateTrigger='onBlur'
                layout='vertical'
                className={tileStyles.listTile}
                onFinish={handleFormSubmit}
              >
                <ClusterOutlined />
                <Form.Item name='name' rules={[{ required: true }]} noStyle>
                  <Input
                    type='text'
                    name='name'
                    placeholder='Введите название модели шлема'
                    style={{ width: '75%' }}
                    onChange={ev => setNewEntity(e => ({ ...e, name: ev.target.value }))}
                  />
                </Form.Item>
                <Button htmlType='button' type='default' onClick={() => setCreateMode(false)}>
                  Отменить
                </Button>
                <Button htmlType='submit' type='primary' disabled={newEntity.name === ''}>
                  Создать
                </Button>
              </Form>
            )}
            {types.map(c => (
              <div key={c.name} className={tileStyles.listTile}>
                <Link to={`/settings/device-types/${c.name}`} className={tileStyles.tileName}>
                  <Space>
                    <ClusterOutlined />
                    <span>{c.name}</span>
                  </Space>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.sidebar}>
          <Space>
            <Button type='primary' onClick={handleCreateButtonClick}>
              Создать новую группу
            </Button>
          </Space>
        </div>
      </div>
    </MainLayout>
  );
};

const DeviceTypesPageBlock: React.FC = () => {
  const dispatch = useDispatch();
  const devicesState = useDevicesState();

  useEffect(() => {
    dispatch(fetchDeviceTypes({}));
  }, [dispatch]);

  if (devicesState.isPending) {
    return (
      <MainLayout>
        <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
          <Spin size={'large'} />
        </Row>
      </MainLayout>
    );
  }

  return <DeviceTypesPage />;
};

export default DeviceTypesPageBlock;
